export const MOCK_ACTIVE = false;
export const MOCK_TEST_ID = '';

export const SOURCE_DEFAULT = 'LF7';
export const CHANNEL_DEFAULT = 'web';
export const PLACE_DEFAULT = 'home_1';
export const LAZY = false;
export const SMILES_BASE_URL = '';
export const PREFIX_VARIANT_STORAGE = 'recsys-template-variant';
export const API_LIVERAY_URL = 'https://api-cms-portal-{{env}}.smiles.com.br';
export const JWT_MEMBER_NUMBER_KEY = 'https://smiles.api/memberNumber';

export const LOGIN_VOUCHER_REDIRECT_KEY = 'voucherModal';
export const LOGIN_VOUCHER_REDIRECT_VALUE = 1;
